<template>
  <v-dialog v-model="dialog" max-width="700" persistent>
    <v-card>
      <v-card-title>
        <v-icon left color="success">mdi-check-circle</v-icon>
        {{ tituloModal }}
      </v-card-title>
      
      <v-card-text>
        <v-alert v-if="error" type="error" dismissible @input="error = null">
          {{ error }}
          <v-btn v-if="!esErrorDefinitivo" @click="emitirFactura" small text class="ml-2">
            <v-icon left>mdi-refresh</v-icon>
            Reintentar
          </v-btn>
        </v-alert>
        
        <!-- Paso 1: Elegir acción -->
        <div v-if="paso === 1">
          <v-btn block color="primary" x-large @click="paso = 2" class="mb-3">
            <v-icon left>mdi-file-document</v-icon>
            Emitir factura ahora
          </v-btn>
          
          <v-btn block color="warning" x-large @click="marcarPendiente" class="mb-3">
            <v-icon left>mdi-clock-outline</v-icon>
            Marcar como pendiente (emitir después)
          </v-btn>
          
          <v-btn block text @click="cerrar">
            {{ textoNoRequiereFactura }}
          </v-btn>
        </div>
        
        <!-- Paso 2: Datos del cliente -->
        <div v-if="paso === 2 && !procesando && !facturaEmitida">
          <v-select
            v-model="tipoComprobante"
            :items="tiposComprobanteLista"
            label="Tipo de factura *"
            outlined
            class="mt-3"
          />

          <v-card v-if="mostrarEmailSection" outlined class="invoice-option-card mt-3">
            <v-card-text class="py-3">
              <div class="d-flex align-start justify-space-between flex-wrap">
                <div class="invoice-option-heading">
                  <v-avatar size="34" color="blue lighten-5" class="mr-3">
                    <v-icon color="primary">mdi-email-outline</v-icon>
                  </v-avatar>
                  <div>
                    <div class="text-subtitle-2 font-weight-medium">Envío al comprador</div>
                    <div class="text-caption grey--text text--darken-1">
                      Adjuntamos el PDF del comprobante cuando termina la emisión.
                    </div>
                  </div>
                </div>
                <v-switch
                  v-model="enviarPorEmail"
                  inset
                  dense
                  color="primary"
                  hide-details
                  class="mt-0"
                  label="Enviar por email"
                />
              </div>

              <v-expand-transition>
                <div v-if="enviarPorEmail" class="mt-3">
                  <v-text-field
                    v-model="emailFacturaB"
                    type="email"
                    :label="emailComprobanteLabel"
                    placeholder="ejemplo@correo.com"
                    outlined
                    dense
                    :required="tipoComprobante === 'FACTURA_B'"
                    :rules="tipoComprobante === 'FACTURA_B' ? rulesEmailFacturaB : []"
                    :hint="emailComprobanteHint"
                    persistent-hint
                  />
                </div>
              </v-expand-transition>
            </v-card-text>
          </v-card>
          
          <!-- Selector de cliente: obligatorio Factura A, opcional Factura B y Factura X -->
          <v-card v-if="mostrarClienteSelector" outlined class="invoice-option-card mt-3">
            <v-card-text class="py-3">
              <div class="invoice-option-heading mb-3">
                <v-avatar size="34" color="green lighten-5" class="mr-3">
                  <v-icon color="success">mdi-account-circle-outline</v-icon>
                </v-avatar>
                <div>
                  <div class="text-subtitle-2 font-weight-medium">Datos del receptor</div>
                  <div class="text-caption grey--text text--darken-1">{{ clienteHelpText }}</div>
                </div>
              </div>

            <v-autocomplete
              v-model="clienteId"
              :items="clientes"
              item-text="razonSocial"
              item-value="id"
              :label="clienteAutocompleteLabel"
              outlined
              dense
              clearable
              :loading="loadingClientes"
              :search-input.sync="searchCliente"
              persistent-hint
              prepend-inner-icon="mdi-account-search"
            >
              <template v-slot:append-outer>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="primary"
                      icon
                      v-bind="attrs"
                      v-on="on"
                      @click="mostrarModalCrearCliente = true"
                    >
                      <v-icon>mdi-account-plus</v-icon>
                    </v-btn>
                  </template>
                  <span>Crear nuevo cliente</span>
                </v-tooltip>
              </template>
              
              <template v-slot:no-data>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="text-center">
                      No se encontraron clientes
                    </v-list-item-title>
                    <v-btn 
                      block 
                      color="primary" 
                      class="mt-2" 
                      @click="mostrarModalCrearCliente = true"
                    >
                      <v-icon left>mdi-plus</v-icon>
                      Crear primer cliente
                    </v-btn>
                  </v-list-item-content>
                </v-list-item>
              </template>
              
              <template v-slot:item="{ item }">
                <v-list-item-content>
                  <v-list-item-title>{{ item.razonSocial }}</v-list-item-title>
                  <v-list-item-subtitle>
                    {{ item.tipoDocumento }}: {{ item.numeroDocumento }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-autocomplete>
            
            <!-- Información del cliente seleccionado -->
              <v-alert v-if="clienteSeleccionado" type="info" dense text class="mb-0">
                <strong>{{ clienteSeleccionado.razonSocial }}</strong><br>
                {{ clienteSeleccionado.tipoDocumento }}: {{ clienteSeleccionado.numeroDocumento }}<br>
                <span v-if="clienteSeleccionado.email">Email: {{ clienteSeleccionado.email }}</span>
              </v-alert>
            </v-card-text>
          </v-card>
        </div>
        
        <!-- Modal Crear Cliente Rápido -->
        <ClienteCreateQuickModal
          v-model="mostrarModalCrearCliente"
          :tipo-factura="tipoComprobante"
          @cliente-creado="onClienteCreado"
        />
        
        <!-- Paso 3: Procesando -->
        <div v-if="procesando" class="text-center py-8">
          <v-progress-circular indeterminate color="primary" size="64" />
          <p class="mt-4 text-h6">{{ tipoComprobante === 'FACTURA_X' ? 'Generando factura...' : 'Emitiendo factura en AFIP...' }}</p>
          <p class="caption">Por favor espere...</p>
        </div>
        
        <!-- Paso 4: Éxito -->
        <div v-if="facturaEmitida">
          <v-alert type="success" prominent>
            <strong>¡Factura emitida exitosamente!</strong>
          </v-alert>
          
          <v-list>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle>Tipo</v-list-item-subtitle>
                <v-list-item-title class="text-h6">{{ factura.tipoComprobante.replace('_', ' ') }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle>Número</v-list-item-subtitle>
                <v-list-item-title class="text-h6">
                  {{ factura.tipoComprobante === 'FACTURA_X' ? String(factura.numeroComprobante).padStart(8, '0') : String(factura.puntoVenta).padStart(4, '0') + '-' + String(factura.numeroComprobante).padStart(8, '0') }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            
            <v-list-item v-if="factura.tipoComprobante !== 'FACTURA_X'">
              <v-list-item-content>
                <v-list-item-subtitle>CAE</v-list-item-subtitle>
                <v-list-item-title>{{ factura.CAE }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-else>
              <v-list-item-content>
                <v-list-item-subtitle>CAE</v-list-item-subtitle>
                <v-list-item-title>N/A (Factura X)</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle>Total</v-list-item-subtitle>
                <v-list-item-title class="text-h6 green--text">${{ factura.total.toFixed(2) }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </div>
      </v-card-text>
      
      <v-card-actions>
        <v-spacer />
        
        <v-btn v-if="paso === 2 && !procesando && !facturaEmitida" text @click="paso = 1">
          <v-icon left>mdi-arrow-left</v-icon>
          Atrás
        </v-btn>
        
        <v-btn
          v-if="paso === 2 && !procesando && !facturaEmitida"
          color="primary"
          @click="emitirFactura"
          :disabled="!puedeEmitir"
          large
        >
          <v-icon left>mdi-check</v-icon>
          Emitir Factura
        </v-btn>
        
        <v-btn text @click="cerrar" :disabled="procesando">
          Cerrar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ClienteCreateQuickModal from '../ClienteCreateQuickModal'
import ClienteProvider from '../../../cliente/providers/ClienteProvider'
import CompanyProvider from '../../../base/providers/CompanyProvider'
import FacturacionProvider from '../../providers/FacturacionProvider'

export default {
  name: 'FacturaEmitirModal',
  
  components: {
    ClienteCreateQuickModal
  },
  
  props: {
    value: Boolean,
    movimiento: Object,
    tipoComprobanteInicial: {
      type: String,
      default: null
    },
    /** Si es true, al abrir se muestra directo el paso 2 (formulario de emisión), sin la pantalla de elegir Emitir/Marcar pendiente/No requiere. */
    skipChoiceStep: {
      type: Boolean,
      default: false
    },
    /** movimiento: flujo caja (elegir cliente/email). ordenVenta: datos del documento ya elegidos. */
    contextoEmision: {
      type: String,
      default: 'movimiento'
    },
    /** Cliente de la OV (id, razonSocial, email) cuando contextoEmision es ordenVenta */
    documentoCliente: {
      type: Object,
      default: null
    },
    ordenVentaId: {
      type: String,
      default: null
    }
  },
  
  data() {
    return {
      dialog: false,
      paso: 1,
      tipoComprobante: null,
      emailFacturaB: '',
      enviarPorEmail: true,
      clienteId: null,
      procesando: false,
      error: null,
      esErrorDefinitivo: false,
      facturaEmitida: false,
      factura: null,
      esFacturaPendiente: false, // Para saber si viene desde facturas pendientes
      
      // Cliente
      clientes: [],
      loadingClientes: false,
      searchCliente: null,
      mostrarModalCrearCliente: false,
      userHasSearchedCliente: false, // Evita bucle: solo recargar al vaciar si el usuario había buscado
      skipSearchClienteUntil: 0, // Tras crear cliente, ignorar actualizaciones de searchCliente del autocomplete
      
      tiposComprobanteTodos: [
        { text: 'Factura B (Consumidor Final)', value: 'FACTURA_B' },
        { text: 'Factura A (Responsable Inscripto)', value: 'FACTURA_A' },
        { text: 'Factura X', value: 'FACTURA_X' }
      ],
      afipActivo: true,
      envioEmailHabilitado: true,
    }
  },
  
  computed: {
    userCompanyId() {
      return this.$store.state.user.companyId
    },
    
    tituloModal() {
      if (!this.movimiento) return '¿Emitir factura?'
      
      if (this.movimiento.tipo === 'DEVOLUCION') {
        return 'Devolución completada - ¿Emitir factura?'
      }
      
      return 'Venta completada - ¿Emitir factura?'
    },
    
    textoNoRequiereFactura() {
      if (!this.movimiento) return 'No requiere factura'
      
      if (this.movimiento.tipo === 'DEVOLUCION') {
        return 'Esta devolución no requiere factura'
      }
      
      return 'Esta venta no requiere factura'
    },
    
    puedeEmitir() {
      if (!this.tipoComprobante) {
        return false
      }
      
      // Factura A: requiere cliente
      if (this.tipoComprobante === 'FACTURA_A') {
        return !!(this.clienteId || (this.documentoCliente && this.documentoCliente.id))
      }
      
      // Factura B: email obligatorio; cliente opcional
      if (this.tipoComprobante === 'FACTURA_B') {
        if (!this.enviarPorEmail) return true
        const email = (this.emailFacturaB && this.emailFacturaB.trim()) || (this.clienteSeleccionado && this.clienteSeleccionado.email) || (this.documentoCliente && this.documentoCliente.email && String(this.documentoCliente.email).trim())
        return !!email
      }
      
      // Factura X: solo requiere tipo seleccionado
      if (this.tipoComprobante === 'FACTURA_X') {
        return true
      }
      
      return true
    },
    
    clienteSeleccionado() {
      if (!this.clienteId) return null
      return this.clientes.find(c => c.id === this.clienteId)
    },
    rulesEmailFacturaB() {
      const required = (v) => ((v && v.trim()) || this.emailFallback) ? true : 'El email es obligatorio'
      const emailValid = (v) => !v || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || 'Email inválido'
      return [required, emailValid]
    },
    tiposComprobanteLista() {
      if (!this.afipActivo) {
        return this.tiposComprobanteTodos.filter((t) => t.value === 'FACTURA_X')
      }
      return this.tiposComprobanteTodos
    },
    mostrarEmailSection() {
      return this.envioEmailHabilitado && (this.tipoComprobante === 'FACTURA_B' || this.tipoComprobante === 'FACTURA_X')
    },
    mostrarClienteSelector() {
      return this.contextoEmision !== 'ordenVenta' && ['FACTURA_A', 'FACTURA_B', 'FACTURA_X'].includes(this.tipoComprobante)
    },
    emailComprobanteLabel() {
      return this.tipoComprobante === 'FACTURA_B'
        ? 'Email del comprador *'
        : 'Email del comprador'
    },
    emailComprobanteHint() {
      if (!this.emailFacturaB && this.emailFallback) {
        return `Si dejás este campo vacío, se usará ${this.emailFallback}`
      }
      return this.tipoComprobante === 'FACTURA_B'
        ? 'Necesario para enviar la factura en PDF'
        : 'Opcional: se enviará el comprobante X en PDF'
    },
    emailFallback() {
      return (this.clienteSeleccionado && this.clienteSeleccionado.email) ||
        (this.documentoCliente && this.documentoCliente.email && String(this.documentoCliente.email).trim()) ||
        ''
    },
    clienteAutocompleteLabel() {
      if (this.tipoComprobante === 'FACTURA_A') return 'Cliente Responsable Inscripto *'
      if (this.tipoComprobante === 'FACTURA_B') return 'Cliente consumidor final (opcional)'
      return 'Cliente (opcional)'
    },
    clienteHelpText() {
      if (this.tipoComprobante === 'FACTURA_A') {
        return 'Requerido para emitir factura A. Debe ser Responsable Inscripto.'
      }
      if (this.tipoComprobante === 'FACTURA_B') {
        return 'Podés asociar comprador cargado o emitir a consumidor final.'
      }
      return 'Opcional. Sirve para dejar el comprobante vinculado al cliente.'
    },
  },
  
  watch: {
    value(val) {
      this.dialog = val
      if (val) {
        if (this.movimiento && this.contextoEmision !== 'ordenVenta') {
          this.esFacturaPendiente = true
        } else {
          this.esFacturaPendiente = false
        }

        if (this.tipoComprobanteInicial) {
          this.tipoComprobante = this.tipoComprobanteInicial
        }
        if (this.skipChoiceStep || this.tipoComprobanteInicial) {
          this.paso = 2
        }

        this.cargarAfipActivo().then(() => {
          if (!this.tipoComprobanteInicial && !this.afipActivo) {
            this.tipoComprobante = 'FACTURA_X'
          }
          if (this.contextoEmision === 'ordenVenta' && this.documentoCliente && this.documentoCliente.id) {
            this.clienteId = this.documentoCliente.id
            this.emailFacturaB = (this.documentoCliente.email && String(this.documentoCliente.email).trim()) || ''
            this.enviarPorEmail = !!this.emailFacturaB
          }
          if (this.contextoEmision !== 'ordenVenta' && (this.tipoComprobante === 'FACTURA_A' || this.tipoComprobante === 'FACTURA_B' || this.tipoComprobante === 'FACTURA_X')) {
            this.cargarClientes()
          }
        })
      }
    },
    
    dialog(val) {
      this.$emit('input', val)
    },
    
    searchCliente(val) {
      if (Date.now() < this.skipSearchClienteUntil) return
      if (val && val.length > 2) {
        this.userHasSearchedCliente = true
        this.buscarClientes(val)
      } else if ((!val || val.length === 0) && this.userHasSearchedCliente) {
        // Solo recargar cuando el usuario borra la búsqueda (evita bucle con v-autocomplete)
        this.userHasSearchedCliente = false
        this.cargarClientes()
      }
    },
    
    tipoComprobante(val) {
      if (this.contextoEmision === 'ordenVenta') {
        if (this.documentoCliente && this.documentoCliente.id) {
          this.clienteId = this.documentoCliente.id
          if (val === 'FACTURA_B' || val === 'FACTURA_X') {
            this.emailFacturaB = (this.documentoCliente.email && String(this.documentoCliente.email).trim()) || ''
            this.enviarPorEmail = !!this.emailFacturaB
          } else {
            this.emailFacturaB = ''
            this.enviarPorEmail = false
          }
        }
        return
      }
      if ((val === 'FACTURA_A' || val === 'FACTURA_B' || val === 'FACTURA_X') && this.clientes.length === 0) {
        this.cargarClientes()
      }
      if (val !== 'FACTURA_B' && val !== 'FACTURA_X') {
        this.emailFacturaB = ''
        this.enviarPorEmail = false
      } else {
        this.enviarPorEmail = true
      }
      this.clienteId = null
      this.clientes = []
    }
  },
  
  methods: {
    async cargarAfipActivo() {
      try {
        const response = await CompanyProvider.companyAfipStatus()
        const st = response.data && response.data.companyAfipStatus
        this.afipActivo = !!(st && st.afipActivo)
        this.envioEmailHabilitado = st ? st.envioEmailHabilitado !== false : false
        if (!this.envioEmailHabilitado) {
          this.enviarPorEmail = false
        }
      } catch (e) {
        console.error(e)
        this.afipActivo = false
        this.envioEmailHabilitado = false
        this.enviarPorEmail = false
      }
    },
    async cargarClientes() {
      this.loadingClientes = true
      try {
        let filters = {
          companyId: this.userCompanyId
        }
        
        if (this.tipoComprobante === 'FACTURA_A') {
          filters.condicionIVA = 'RESPONSABLE_INSCRIPTO'
        } else if (this.tipoComprobante === 'FACTURA_B') {
          filters.condicionIVA = 'CONSUMIDOR_FINAL'
        }
        // Factura X: sin filtro por condición IVA (cualquier cliente)
        
        const response = await ClienteProvider.paginateClientes(1, 50, '', null, false, filters)
        this.clientes = response.data.clientePaginate.items
      } catch (err) {
        console.error('Error cargando clientes:', err)
        this.error = 'Error al cargar clientes: ' + err.message
      } finally {
        this.loadingClientes = false
      }
    },
    
    async buscarClientes(search) {
      this.loadingClientes = true
      try {
        let filters = {
          companyId: this.userCompanyId
        }
        
        if (this.tipoComprobante === 'FACTURA_A') {
          filters.condicionIVA = 'RESPONSABLE_INSCRIPTO'
        } else if (this.tipoComprobante === 'FACTURA_B') {
          filters.condicionIVA = 'CONSUMIDOR_FINAL'
        }
        // Factura X: sin filtro por condición IVA
        
        const response = await ClienteProvider.paginateClientes(1, 20, search, null, false, filters)
        this.clientes = response.data.clientePaginate.items
      } catch (err) {
        console.error('Error buscando clientes:', err)
        this.error = 'Error al buscar clientes: ' + err.message
      } finally {
        this.loadingClientes = false
      }
    },
    
    onClienteCreado(cliente) {
      this.skipSearchClienteUntil = Date.now() + 800
      this.clientes.unshift(cliente)
      this.clienteId = cliente.id
      this.$emit('mensaje', {
        tipo: 'success',
        texto: `Cliente "${cliente.razonSocial}" creado y seleccionado`
      })
    },
    
    async emitirFactura() {
      this.procesando = true
      this.error = null
      
      try {
        const email = this.enviarPorEmail && (this.tipoComprobante === 'FACTURA_B' || this.tipoComprobante === 'FACTURA_X')
          ? ((this.emailFacturaB && this.emailFacturaB.trim()) || (this.clienteSeleccionado && this.clienteSeleccionado.email) || (this.documentoCliente && this.documentoCliente.email && String(this.documentoCliente.email).trim()))
          : null
        const clienteEmitir =
          this.clienteId || (this.documentoCliente && this.documentoCliente.id) || null;
        const movimientoId =
          this.contextoEmision === 'ordenVenta'
            ? (this.movimiento && this.movimiento.id) || null
            : this.movimiento.id;
        const response = await FacturacionProvider.emitirFactura(
          movimientoId,
          clienteEmitir,
          this.tipoComprobante,
          email,
          this.contextoEmision === 'ordenVenta' ? 'ORDEN_VENTA' : 'MOVIMIENTO',
          this.ordenVentaId || null
        )
        
        this.factura = response.data.facturaEmitir
        this.facturaEmitida = true
        
        this.$emit('factura-emitida', this.factura)
        this.$emit('mensaje', {
          tipo: 'success',
          texto: 'Factura emitida correctamente'
        })
        
        // Si se abrió desde facturas pendientes, cerrar automáticamente después de 2 segundos
        if (this.esFacturaPendiente) {
          setTimeout(() => {
            this.cerrar()
          }, 2000)
        }
        
      } catch (err) {
        this.error = this.procesarError(err)
      } finally {
        this.procesando = false
      }
    },
    
    async marcarPendiente() {
      try {
        await FacturacionProvider.marcarFacturaPendiente(this.movimiento.id)
        
        this.$emit('mensaje', {
          tipo: 'warning',
          texto: 'Factura marcada como pendiente'
        })
        this.cerrar()
      } catch (err) {
        this.error = err.message
        this.$emit('mensaje', {
          tipo: 'error',
          texto: err.message
        })
      }
    },
    
    procesarError(err) {
      const erroresDefinitivos = [
        'CUIT inválido',
        'Punto de venta no está autorizado',
        'Certificado digital venció',
        'no está autorizado'
      ]
      
      this.esErrorDefinitivo = erroresDefinitivos.some(
        e => err.message.includes(e)
      )
      
      return err.message
    },
    
    cerrar() {
      this.dialog = false
      setTimeout(() => {
        this.paso = 1
        this.facturaEmitida = false
        this.error = null
        this.factura = null
        this.clienteId = null
        this.emailFacturaB = ''
        this.enviarPorEmail = true
        this.tipoComprobante = null
        this.esFacturaPendiente = false
        this.userHasSearchedCliente = false
        this.skipSearchClienteUntil = 0
      }, 300)
    }
  }
}
</script>

<style scoped>
.invoice-option-card {
  border-color: #dbe6f0;
  background: #fbfdff;
}

.invoice-option-heading {
  display: flex;
  align-items: flex-start;
  min-width: 0;
}
</style>
